'use strict';

module.exports = [{
    name: 'react--header-cart',
    module: require('cart')
}, {
    name: 'react--checkout',
    module: require('checkout')
}, {
    name: 'react--offcanvas',
    module: require('offcanvas/offcanvasToggle')
}, {
    name: 'react--contact',
    module: require('contact')
}];



// WEBPACK FOOTER //
// ./static/app/components.js